import { CORE } from "./commonRepository";

/**
 * List of bots
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/bots', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * List of bots
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetByGuid = async (guid) =>{
    try{
        const result = await CORE.get(`v1/bots/${guid}`);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * Create of bots
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Create = async (model) =>{
    try{
        const result = await CORE.post('v1/bots', model);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * Delete of bots
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Delete = async (guid) =>{
    try{
        const result = await CORE.delete(`v1/bots/${guid}`);
        return result;
    }catch(error){
        return error.response;
    }
};